<div class="dynamic-fees-table">
  <div class="p-field p-grid">
    <div class="p-col-12">
      <span class="setting-helper-text">When Shared Offer Sets are enabled, purchase fee configurations must remain consistent across linked accounts.</span>
    </div>
  </div>

  @if (feeRows.length === 0) {
    <div class="p-field p-grid dynamic-fees-table__empty-state">
      <div class="p-col-12">
        No fee rows are configured yet.
      </div>
    </div>
  }

  <div *ngFor="let feeRow of feeRows.controls; let index = index" [formGroup]="feeRow" class="p-fluid p-mb-4 dynamic-fees-table__row">
    <div class="dynamic-fees-table__fields">
      <div class="dynamic-fees-table__field dynamic-fees-table__field--fee-type">
        <label [for]="'fee-type-' + categoryName + '-' + index">Fee Type</label>
        <p-select
          [options]="feeTypeOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="type"
          [inputId]="'fee-type-' + categoryName + '-' + index"
          (onChange)="handleFeeTypeChange(index)">
        </p-select>
        @if (feeRow.get('isDefaultDocumentFee')?.value === true) {
          <small class="dynamic-fees-table__hint">Default document fee row</small>
        }

        <label [for]="'purchase-display-name-' + categoryName + '-' + index">Fee Title (Shown in Math Box)</label>
        <input
          type="text"
          pInputText
          class="dynamic-fees-table__secondary-input"
          formControlName="purchaseDisplayName"
          [id]="'purchase-display-name-' + categoryName + '-' + index"
          [maxlength]="feeTitleMaxLength"
          aria-label="Fee Title Shown in Math Box"
          placeholder="Customer-facing display name">
        <div class="dynamic-fees-table__helper">
          When blank, uses the Fee Type name.
        </div>
        @if (feeRow.get('purchaseDisplayName')?.touched && (feeRow.get('purchaseDisplayName')?.hasError('required') || feeRow.get('purchaseDisplayName')?.hasError('pattern'))) {
          <small class="p-error dynamic-fees-table__error">Fee title is required for Other / Custom.</small>
        }
        @if (feeRow.get('purchaseDisplayName')?.touched && feeRow.get('purchaseDisplayName')?.hasError('maxlength')) {
          <small class="p-error dynamic-fees-table__error">Fee title cannot exceed {{feeTitleMaxLength}} characters.</small>
        }
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'fee-value-' + categoryName + '-' + index">{{getValueLabel(index)}}</label>
        <input
          type="text"
          pInputText
          formControlName="value"
          [id]="'fee-value-' + categoryName + '-' + index">
        <div class="dynamic-fees-table__helper">
          Open-entry amount
        </div>
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'purchase-behavior-' + categoryName + '-' + index">Purchase</label>
        <p-select
          [options]="purchaseBehaviorOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="purchaseBehavior"
          [inputId]="'purchase-behavior-' + categoryName + '-' + index"
          (onChange)="handlePurchaseBehaviorChange(index)">
        </p-select>
        <div class="dynamic-fees-table__helper">
          Defines whether the fee already exists in the selling price or should be added.
        </div>
        @if (purchaseDisplayPositionAvailable) {
          <label [for]="'purchase-display-position-' + categoryName + '-' + index">Purchase Display Position</label>
          <p-select
            [options]="purchaseDisplayPositionOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="purchaseDisplayPosition"
            [inputId]="'purchase-display-position-' + categoryName + '-' + index">
          </p-select>
          <div class="dynamic-fees-table__helper">
            Controls whether this fee appears above or below the purchase subtotal in the mathbox.
          </div>
        }
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'lease-behavior-' + categoryName + '-' + index">Lease</label>
        <p-select
          [options]="paymentBehaviorOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="leaseBehavior"
          [inputId]="'lease-behavior-' + categoryName + '-' + index">
        </p-select>
        <div class="dynamic-fees-table__helper">
          Controls how this fee is collected for lease offers.
        </div>
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'finance-behavior-' + categoryName + '-' + index">Finance</label>
        <p-select
          [options]="financeBehaviorOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="financeBehavior"
          [inputId]="'finance-behavior-' + categoryName + '-' + index">
        </p-select>
        <div class="dynamic-fees-table__helper">
          Controls how this fee is collected for finance offers.
        </div>

        @if (canRemoveRow(index)) {
          <div class="dynamic-fees-table__actions">
            <button
              type="button"
              pButton
              class="dynamic-fees-table__remove-button"
              label="Remove"
              (click)="removeFeeRow(index)">
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <button
    type="button"
    pButton
    label="Add Fee Row"
    icon="pi pi-plus"
    (click)="addFeeRow()">
  </button>
</div>
